// Generated by ReScript, PLEASE EDIT WITH CARE

import * as RewardCategory from "../domain/types/RewardCategory.bs.js";

function getRouteTitleString(route) {
  switch (route.TAG | 0) {
    case /* RnrHome */0 :
        return "RnR Home";
    case /* RewardHistory */1 :
        return "RnR Reward History";
    case /* RnrReward */2 :
        return "RnR Reward Info" + RewardCategory.toString(route._1);
    case /* AwardHistory */3 :
        return "RnR Award History";
    case /* Tnc */4 :
        return "RnR TnC";
    
  }
}

function getRoutePathString(route) {
  switch (route.TAG | 0) {
    case /* RnrHome */0 :
        return "rnr/home";
    case /* RewardHistory */1 :
        return "rnr/reward_history";
    case /* RnrReward */2 :
        return "rnr/reward_info/" + RewardCategory.toString(route._1);
    case /* AwardHistory */3 :
        return "rnr/award_history";
    case /* Tnc */4 :
        return "rnr/tnc";
    
  }
}

export {
  getRouteTitleString ,
  getRoutePathString ,
  
}
/* No side effect */
